import gql from 'graphql-tag';
import workflowFragment from '../workflow';

export default gql`
  fragment stopWorkflowProspectActivityFragment on StopWorkflowProspectActivity {
    workflow {
      ...workflowFragment
    }
  }
  ${workflowFragment}
`;
